import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAssetCancellationRequestDetailsParamsRawI,
	LWApiPublicAssetCancellationRequestDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/asset/cancellation/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ASSET_CANCELLATION_REQUEST_DETAILS_QUERY_KEY =
	'/asset/cancellation/request/details';

const useAssetCancellationRequestDetails = (
	params: LWApiPublicAssetCancellationRequestDetailsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAssetCancellationRequestDetailsResultRawI,
		ApiErrorI
	>,
) => {
	return useQuery({
		queryKey: [ASSET_CANCELLATION_REQUEST_DETAILS_QUERY_KEY, params],
		queryFn: () => api.asset.cancellation.request.apiRaw.details(params),
		...options,
	});
};

export default useAssetCancellationRequestDetails;
